import {HotelRegion} from './hotel-region';

/**
 * Map of default URLs to use for different regions.
 * Used in cases when appropriate URL was not set in configuration files.
 * Ex regions_dict
 */
export const REGION_URLS_MAP: {
  [region in HotelRegion]: {
    admin_url: string;
    static_url: string;
    queue_url: string;
    remotedebug_url: string;
    stat_url: string;
    remoteStateUrl: string;
    eventBridgeUrl: string;
    chili_url?: string;
  };
} = {
  local: {
    admin_url: 'admin',
    static_url: 'static',
    queue_url: 'queue',
    remotedebug_url: 'weinre',
    stat_url: 'stat',
    remoteStateUrl: 'rs',
    eventBridgeUrl: 'eb',
  },
  eu: {
    admin_url: 'api.hoteza.com',
    static_url: 'static.hoteza.com',
    queue_url: 'queue.hoteza.com',
    remotedebug_url: 'weinre.hoteza.com',
    chili_url: 'chili.hoteza.com',
    stat_url: 'stat.hoteza.com',
    remoteStateUrl: 'rs.hoteza.com/ws',
    eventBridgeUrl: 'eb.hoteza.com/ws',
  },
  ru: {
    admin_url: 'api.hoteza.ru',
    static_url: 'static.hoteza.ru',
    queue_url: 'queue.hoteza.ru',
    remotedebug_url: 'weinre.hoteza.com',
    chili_url: 'chili.hoteza.com',
    stat_url: 'stat.hoteza.ru',
    remoteStateUrl: 'rs.hoteza.com/ws',
    eventBridgeUrl: 'eb.hoteza.com/ws',
  },
  cn: {
    admin_url: 'cn-api.hoteza.com',
    static_url: 'cn-static.hoteza.com',
    queue_url: 'cn-queue.hoteza.com',
    remotedebug_url: 'weinre.hoteza.com',
    chili_url: 'chili.hoteza.com',
    stat_url: 'cn-stat.hoteza.com',
    remoteStateUrl: 'rs.hoteza.com/ws',
    eventBridgeUrl: 'eb.hoteza.com/ws',
  },
  bn: {
    admin_url: 'api.blacknova.co',
    static_url: 'static.blacknova.co',
    queue_url: 'queue.blacknova.co',
    remotedebug_url: 'weinre.hoteza.com',
    chili_url: 'chili.hoteza.com',
    stat_url: 'stat.hoteza.com',
    remoteStateUrl: 'rs.hoteza.com/ws',
    eventBridgeUrl: 'eb.hoteza.com/ws',
  },
  na: {
    admin_url: 'na-api.hoteza.com',
    static_url: 'na-static.hoteza.com',
    queue_url: 'na-queue.hoteza.com',
    remotedebug_url: 'weinre.hoteza.com',
    chili_url: 'chili.hoteza.com',
    stat_url: 'na-stat.hoteza.com',
    remoteStateUrl: 'rs.hoteza.com/ws',
    eventBridgeUrl: 'eb.hoteza.com/ws',
  },
};

window.regions_dict = REGION_URLS_MAP;
